var o = "_caption_1m307_1",
    m = "_emojiList_1m307_8",
    i = "_emoji_1m307_8",
    t = "_emojiSymbol_1m307_24",
    e = {
  caption: o,
  emojiList: m,
  emoji: i,
  emojiSymbol: t
};
export { o as caption, e as default, i as emoji, m as emojiList, t as emojiSymbol };